// extracted by mini-css-extract-plugin
export var dropdownContainer = "_41-5";
export var imageContainer = "_41-4";
export var metricsGrid = "_41-2";
export var productDetailContainer = "_41-1";
export var productListContainer = "_41-0";
export var subscriberTableContainer = "_41-3";